import { useTranslation } from 'react-i18next';
import BulkActionsBubble, {
  BulkAction,
} from 'src/components/atoms/bulk-actions-bubble/bulk-actions-bubble';
import { usePermissions } from 'src/permissions/can';

interface Props {
  selectedEmployees: string[];
  previousSelectedEmployees: string[];
  onDelete: () => void;
  allItemsCount: number;
  handleClearSelected: () => void;
  toggleAllSelection: (isChecked: boolean, rows: string[]) => void;
  allEmployeesTokens: string[];
  handlePreviousRowSelection: () => void;
  isAllEmployeesFromCurrentPageSelected: boolean;
}

export const EmployeesBulkActionsBubble = ({
  selectedEmployees,
  previousSelectedEmployees,
  onDelete,
  allItemsCount,
  handleClearSelected,
  toggleAllSelection,
  allEmployeesTokens,
  handlePreviousRowSelection,
  isAllEmployeesFromCurrentPageSelected,
}: Props) => {
  const { t } = useTranslation();
  const permissions = usePermissions();

  const actions: BulkAction[] = [
    {
      id: 'delete',
      disabled: permissions.cannot('delete', 'Employees'),
      tooltip: t('common:notSufficientPermissions'),
      label: t('employees:employees.deleteEmployees'),
      onClick: onDelete,
      destructive: true,
    },
  ];

  return (
    <BulkActionsBubble
      isOpen={selectedEmployees.length > 0}
      selectedItemsCount={selectedEmployees.length}
      actions={actions}
      allItemsCount={allItemsCount}
      onClose={handleClearSelected}
      onSelectAll={() => toggleAllSelection(true, allEmployeesTokens)}
      onPreviousSelection={handlePreviousRowSelection}
      showPreviousSelection={
        selectedEmployees.length !== previousSelectedEmployees.length &&
        isAllEmployeesFromCurrentPageSelected
      }
    />
  );
};
